<template>
    <v-main class="login-content">   
        <v-container fluid grid-list-xl style="max-width: 100%">
                    <v-layout row wrap>
                      <v-flex sm12 xs12 md6 lg6 xl6>
                        <div class="left-login flex1">
        <AnimationCogOrb class="orb" style="width: 100%" />
                    <!-- <Animation25 class="slideExpandUp animate animation" style="width: 100%" /> -->
        <!-- <v-img class="product-animate" style="align-image: center;" src="./../assets/CogneetivAI.png" alt="" /> -->
      </div>
        </v-flex> 
        
        <v-flex sm12 xs12 md6 lg6>
      <div class="form product-animate-out">
        <div class="signIn card">
                  <img image-align="center" style="height: 100px; width: auto" src="@/assets/cogneetiv-logo.png" />
          <h3 style="text-align:center" class="text2">MACHEENIST | CRM</h3>
          <p style="text-align:center" class="text2">powered by Cogneetiv A.I.</p>
          <form autocomplete="off" id="formLogin" name="formLogin" role="form">
            <!-- <div class="form-group">
              <label for="uname1"><div class="text2">Username</div></label>
              <input
                class="form-control"
                id="uname1"
                name="uname1"
                required=""
                type="text"
              />
            </div> -->
            <!-- <div class="form-group">
              <label><div class="text2">Password</div></label>
              <input
                autocomplete="new-password"
                class="form-control"
                id="pwd1"
                required=""
                type="password"
              />
            </div> -->
            <div class="form-check small">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" />
                <span><div class="text2">Remember me on this computer</div></span>
              </label>
            </div>
           <v-btn @click="submit()" outline block class="mt2 btn button"> Login  </v-btn>
          </form>
          <div class="mt2">
            <div class="or-seprator">
              OR
            </div>
            <div class="mt2" v-if="!userInfo.name">
                  <!-- <v-btn  block> Login with Google  </v-btn> -->
                <GoogleLogin :params="params"  :renderParams="renderParams" :onSuccess="onSuccess"  :onFailure="onFailure"></GoogleLogin>
            </div>
            <div v-if="userInfo.name">
                <v-btn @click="submit()" outline block class="mt2 btn"> Face Login  </v-btn>
            </div>
  
          </div>
          <v-overlay :value="overlay" opacity="0.92" z-index="9">
            <v-card style="background-color:rgba(48, 64, 87, 0.4); border-radius: 50px;">
              <br />
                 <div style="text-align: center;">
                   <h3>{{message}}</h3>
                </div>
                            <br />
              <Video  class="box ocrloader" />
            </v-card> 
          </v-overlay>
        </div>
      </div>
    </v-flex>
    
    </v-layout>
    </v-container>
  </v-main>
  </template>
  
  <script>
  import startAudio2 from '@/assets/audio/CogFuture3.wav';
  // import startAudio3 from '@/assets/audio/Scan.wav';
  import { validationMixin } from "vuelidate";
  import { required, maxLength, email } from "vuelidate/lib/validators";
  import GoogleLogin from "vue-google-login";
  import Video from "@/components/FaceDetection.vue";
  import state from "../store/index";
  import AnimationCogOrb from '../components/AnimationCogOrbLogin.vue';
  
  export default {
    mixins: [validationMixin],
  
    validations: {
      name: { required, maxLength: maxLength(10) },
      email: { required, email },
      select: { required },
      checkbox: {
        checked(val) {
          return val;
        },
      },
    },
  
    data: () => ({
      name: "",
      email: "",
      select: null,
      overlay:false,
      checkbox: false,
      message:"Initiating Facial Recognition Scan",
      params: {
        client_id:
          "825571369448-f862qal1sprpso1859ibd9bq3v5pll20.apps.googleusercontent.com",
        scope: "https://mail.google.com/",
        cookiepolicy: 'single_host_origin'
      },
      renderParams: {
        height: 40,
        width:390,
        longtitle: true,
      },
      userInfo:{}
    }),
    components: {
      Video,
      GoogleLogin,
      AnimationCogOrb
    },
    computed: {},
    mounted() {
      this.initSpeechSynthesis();
      this.userInfo = JSON.parse(localStorage.setItem("currentUser"));
  state.commit("initilizeFaceAPI")
  Event.$on("scannCompleted", (username) => {
    if (!this.welcomeSpoken) {  // Check if welcome message has been spoken
      this.message = "Hello " + username.msg ;
      localStorage.setItem("firstTimeMessage", this.message);
      this.readOutLoud(this.message); // Read the message out loud
      this.welcomeSpoken = true;  // Set the flag to true
    }
    localStorage.setItem("currentUser", JSON.stringify(this.info));
        this.$store.commit('setCurrentUser', this.info);
        this.$router.push({ name: "Welcome" });
    });
    },
    methods: {
      submit() {
        //   this.$v.$touch();
        // this.$router.push("home");
        this.overlay=true
        new Audio(startAudio2).play();
      },
      clear() {
        this.$v.$reset();
        this.name = "";
        this.email = "";
        this.select = null;
        this.checkbox = false;
      },
      readOutLoud: (message) => {
      const speech = new SpeechSynthesisUtterance(message);
    const voices = window.speechSynthesis.getVoices();

    const preferredVoice = voices.find(voice => voice.name === "Google UK English Female");
    const fallbackVoice = voices.find(voice => voice.lang.includes('en-GB') && voice.gender === 'female');

    speech.voice = preferredVoice || fallbackVoice || voices[0];  // Use the preferred or fallback voice, or default to the first voice
    speech.pitch = 1;
    speech.rate = 1;
    speech.volume = 1;
      window.speechSynthesis.speak(speech);
      this.displayResponse(message);

      speech.onend = function() {
       setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 4000);
     };
    },
      onSuccess(googleUser) {
        console.log(googleUser);
          let profile = googleUser.getBasicProfile();
          let info = {
            name:profile.getName(),
            profilePic:profile.getImageUrl(),
            email:profile.getEmail()
          };
          
        localStorage.setItem("currentUser", JSON.stringify(info));
        this.$store.commit('setCurrentUser', info);
        this.$router.push({ name: "Welcome" });
        this.readOutLoud("Hello " + info.name);
      },
      onFailure(error) {
        console.log(error);
      },
    }
  };
  </script>
  
  
  <style scoped>
  .login-content {
  background-color: #0c161b;
  background-image: url('./../assets/IGAI5.png');
margin-left: 0;
margin-right: 0;
margin-bottom: -240px;
padding-bottom: 50px;
}
@media only screen and (max-width: 600px) {
  .login-content {
    background: #0c161b;
    background-image: url('./../assets/IGAI4.png');
    background-size: 100%;
    background-repeat: no-repeat;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0px;
  margin-top: 30;
  width: 100%;
  height: 100%;
  }
}
  .login-left {
    padding: 100px;
    background-repeat: no-repeat;
    min-height: 100vh;
    background-color: #101624;
    background-size: 100%;
    background-position: bottom;
    text-align: center;
  }
  .form {
    display: flex;
    justify-content: center;
    background: linear-gradient(-45deg, #0b1017, #141a24);
    color: #ffffff;
    min-height: 100vh;
  }
  .text {
    color: #000417;
  }
  .text2 {
    color: #78b59c;
  }
  .text3 {
    color: #ffffff;
  }
  .left-login {
  background-image: url('./../assets/IGAI6.png');
  width: 100%;
  height: 100vh;
  align-content: center;
align-items: center;
align-self: center;
justify-content: center;
justify-items: center;
justify-self: center;
margin: 0 auto;
max-width: 960px;
min-width: 100%;
left: 20px;
}

@media only screen and (max-width: 600px) {
  .left-login {
  background-image: url('./../assets/IGAI6.png');
  width: auto;
  height: 60vh;
  align-content: center;
align-items: center;
align-self: center;
justify-content: center;
justify-items: center;
justify-self: center;
margin: 0 auto;
}
}
.signIn {
  border: 1px solid #7c5dcd;
  border-radius: 0;
  margin-top: 20;
  top: 30px;
  text-align: left;
  color: #ffffff;
    display: flex;
    flex-direction: column;
  align-content: center;
align-items: center;
align-self: center;
justify-content: center;
justify-items: center;
justify-self: center;
margin: 0 auto;
width: 60%;
height: 700px;
max-height: 800px;  
}

@media only screen and (max-width: 600px) {
  .signIn {
    width: 100%;
    border: 1px solid #580979;
    margin-top: -12vh;
    height: 90vh;
    padding: 20px;
    display: flex;
    flex-direction: column;
    text-align: left;
    color: #ffffff;
  }
}

  .orb {
  width: 90px;
  height: auto;
  margin-top: -425px;
  margin-left: -135px;
  opacity: 1;
}
@media only screen and (max-width: 600px) {
  .orb {
    width: 150px;
    height: 150px;
    margin-top: -160px;
    margin-left: -70px;
    z-index: 1;
    opacity: 1;
  }
}
.card {
  color: rgb(43, 40, 40);
  padding: 40px;
  overflow: hidden;
  border-radius: 5px;
}

@media only screen and (max-width: 600px) {
  .card {
    color: rgb(43, 40, 40);
    padding: 15px;
    overflow: hidden;
    border-radius: 5px;
    min-height: 30vh;
  }
}
  .space2 {
    height: 50px;
  }
  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  
  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  }
  
  .button {
  background: #192b44;
  }
  
  .animate {
    top: 80px;
    left: -420px;
  }
  .product-animate {
    animation-name: slideleft;
    position: relative;
    position-fromTop: 100px;
    animation-duration: 1s;
    transition: opacity 1s Elastic.easeIn;
    opacity: 0.8;
    width:150%; 
    height:90%; 
  }
  @media only screen and (max-width: 600px) {
    .product-animate {
      animation-name: slideleft;
      position: relative;
      position-fromTop: 100px;
      animation-duration: 1s;
      transition: opacity 1s Elastic.easeIn;
      opacity: 0.6;
      width:50%; 
      height:50%; 
    }
  }
  .product-animate-out {
    animation-name: slideright;
    position: relative;
    position-fromTop: 100px;
    animation-duration: 1s;
    transition: opacity 1s Elastic.easeOut;
  }
  
  /* Standard syntax */
  @keyframes slideleft {
    0% {
      left: -800px;
      top: 0px;
      opacity: 0; 
    }
    100% {
      left: 10px;
      top: 0px;
      opacity: 1; 
    }
  }
  /* Standard syntax */
  @keyframes slideright {
    0% {
      left: 800px;
      top: 0px;
      opacity: 0; 
    }
    100% {
      left: 0px;
      top: 0px;
      opacity: 1; 
    }
  }
  .slideExpandUp {
    animation-name: slideExpandUp;
    -webkit-animation-name: slideExpandUp;
  
    animation-duration: 2.6s;
    -webkit-animation-duration: 2.6s;
  
    animation-timing-function: ease-out;
    -webkit-animation-timing-function: ease -out;
  
    visibility: visible !important;
  }
  
  @keyframes slideExpandUp {
    0% {
      transform: translateY(100%) scaleX(0.94);
    }
    30% {
      transform: translateY(-4%) scaleX(0.95);
    }
    40% {
      transform: translateY(2%) scaleX(0.96);
    }
    50% {
      transform: translateY(0%) scaleX(1);
    }
  }
  
  @-webkit-keyframes slideExpandUp {
    0% {
      -webkit-transform: translateY(100%) scaleX(0.94);
    }
    30% {
      -webkit-transform: translateY(-4%) scaleX(0.95);
    }
    40% {
      -webkit-transform: translateY(2%) scaleX(0.96);
    }
    50% {
      -webkit-transform: translateY(0%) scaleX(1);
    }
  }
  .box {
    margin:0px;
    position:relative;
    animation: glow 10000ms ease-out infinite alternate;
    outline: none;
    }
    @keyframes glow {
      0% {
        border-color: #544d6d;
        box-shadow: 0 0 2px rgba(90, 128, 191, 0.2),
          inset 0 0 4px rgba(54, 78, 116, 0.3), 0 2px 0 #000;
      }
  
      100% {
        border-color: #11ece5;
        box-shadow: 0 0 4px rgba(90, 128, 191, 0.3),
          inset 0 0 6px rgba(90, 128, 191, 0.4), 0 4px 0 #000;
      }
    }
  
  .box::before {
    content:"";
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    width:20px;
    background:#18c89b;
    box-shadow:0 0 70px 20px #18c89b;
    clip-path:inset(0);
    animation:
      x 2s ease-in-out infinite alternate,
      y 4s   ease-in-out infinite;
  }
  @keyframes x {
    to {
      transform:translateX(-100%);
      left:100%;
    }
  }
  
  @keyframes y {
     33% {
       clip-path:inset(0 0 0 -100px);    
     }
     50% {
       clip-path:inset(0 0 0 0);    
     }
     83%{
       clip-path:inset(0 -100px 0 0); 
       
     }
  }
  </style>
  